import { SubscriptionStatus, SubscriptionTier } from '../models/User';

export const SUBSCRIPTION_FEATURES: Record<SubscriptionTier, string[]> = {
  free: ['basic_study', 'history'],
  premium: [
    'basic_study',
    'history',
    'notes',
    'ai_study',
    'advanced_analytics',
    'priority_support',
  ],
};

const ACTIVE_SUBSCRIPTION_STATUSES: SubscriptionStatus[] = ['active', 'trial', 'past_due'];

export const getFeaturesForTier = (tier: SubscriptionTier): string[] => {
  return SUBSCRIPTION_FEATURES[tier] ?? SUBSCRIPTION_FEATURES.free;
};

export const isSubscriptionActive = (status?: SubscriptionStatus | null): boolean => {
  if (!status) {
    return false;
  }
  return ACTIVE_SUBSCRIPTION_STATUSES.includes(status);
};

export const STRIPE_PRICE_ID = import.meta.env.VITE_STRIPE_PRICE_ID || '';
export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '';



